import { Tag } from '@factorialco/deprecated-design-system'
import { TimeSettingsEnumsTimeTypeEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

// If the category name is too long, it should be displayed with an ellipsis, however, the time type should always be shown in full.
// e.g. Veryveryveryverylongna... ･ Regular
// The selector label is a simple string, so I cannot apply this logic there. Instead, I'm limiting the length of the text.
const MAX_CATEGORY_NAME_LENGTH = 20
const truncateCategoryName = (categoryName: string) => {
  return categoryName.length > MAX_CATEGORY_NAME_LENGTH
    ? `${categoryName.substring(0, MAX_CATEGORY_NAME_LENGTH)}...`
    : categoryName
}

export const categoryTimeTypeLabel = (timeType: TimeSettingsEnumsTimeTypeEnum) => {
  switch (timeType) {
    case 'overtime':
      return i18n.t('time_tracking.settings.time_blocks.worked_time_categories.overtime')
    case 'regular':
      return i18n.t('time_tracking.settings.time_blocks.worked_time_categories.regular')
    case 'any_time':
      return i18n.t('time_tracking.settings.time_blocks.worked_time_categories.any_time')
    default:
      const exhaustiveCheck: never = timeType
      throw new Error(`Unhandled timeType: ${exhaustiveCheck}`)
  }
}

export const categoryNameWithTimeTypeLabel = (
  name: string,
  timeType: TimeSettingsEnumsTimeTypeEnum
) => {
  return `${truncateCategoryName(name)} ･ ${categoryTimeTypeLabel(timeType)}`
}

export const categoryTimeTypeTag = (timeType: TimeSettingsEnumsTimeTypeEnum) => {
  switch (timeType) {
    case 'overtime':
      return Tag.Types.tangerine
    case 'regular':
      return Tag.Types.grey
    case 'any_time':
      return Tag.Types.purple
    default:
      const exhaustiveCheck: never = timeType
      throw new Error(`Unhandled timeType: ${exhaustiveCheck}`)
  }
}
